import { useMutation } from "@tanstack/react-query";

import { updateConsentDocument } from "../api/consentDocuments";

export const useUpdateConsentDocument = () => {
  return useMutation({
    mutationFn: updateConsentDocument,
  });
};
